import classNames from 'clsx';

import { EClustersType } from 'shared/map-search/types/clustersType';

import * as styles from './BalloonPromoContent.css';
import { formatBalloonCount } from '../utils';
import { Icon } from '../Icon';
import { Icon as IconV2 } from '../IconV2';

export interface IBalloonPromoContentProps {
  count: number;
  price: string;
  isClustersRedesign: boolean;
  isShowDetails: boolean;
  isFavorite: boolean;
  hasNewobject?: boolean;
  isAnyFromKp?: boolean;
  isViewed?: boolean;
  hasDiscountOffers?: boolean;
  isActive?: boolean;
  isHovered?: boolean;
  label?: string;
  details?: string;
  pointType: EClustersType | null;
  newbuildingId: number;
  isNewbuildingOnProPlus: boolean;
  isRedesign: boolean;
}

export const BalloonPromoContent = ({
  count,
  price,
  isClustersRedesign,
  isShowDetails,
  isFavorite,
  hasNewobject,
  isAnyFromKp,
  isViewed,
  hasDiscountOffers,
  isActive,
  isHovered,
  label,
  details,
  pointType,
  newbuildingId,
  isNewbuildingOnProPlus,
  isRedesign,
}: IBalloonPromoContentProps) => {
  const isCounter = count > 1;
  const hasIcon = isFavorite || hasDiscountOffers;

  const icon = isRedesign ? (
    <IconV2 isFavorite={isFavorite} isPromo={hasDiscountOffers} isActive={isActive || isHovered} isViewed={isViewed} />
  ) : (
    <div className={styles['icon']}>
      <Icon
        isFavorite={isFavorite}
        isPromo={hasDiscountOffers}
        isActive={isActive}
        isViewed={isViewed}
        isRedesign={isClustersRedesign || isRedesign}
        isPromoBalloon
      />
    </div>
  );

  return (
    <div
      data-testid={isNewbuildingOnProPlus ? 'promo-pin' : 'promotion-pin'}
      data-newbuilding={newbuildingId}
      className={classNames(styles['promo-wrapper'], {
        [styles['promo-wrapper--redesign']]: isClustersRedesign,
        [styles['promo-wrapper--redesign-v2']]: isRedesign,
        [styles['promo-wrapper--cluster']]: pointType === EClustersType.OpenablePeas && isCounter,
        [styles['promo-wrapper-details']]: isShowDetails,
        [styles['viewed']]: isViewed,
        [styles['counter-wrapper']]: !isClustersRedesign && isCounter,
      })}
    >
      <div
        className={classNames(styles['promo-balloon'], {
          [styles['residential-complex']]: hasNewobject || isAnyFromKp,
          [styles['colorized']]: isNewbuildingOnProPlus,
          [styles['active']]: isActive,
          [styles['promo-balloon--redesign']]: isClustersRedesign,
          [styles['promo-balloon--hovered']]: isHovered && !isActive,
          [styles['promo-balloon--redesign-v2']]: isRedesign,
        })}
      >
        <div
          className={classNames(styles['content'], {
            [styles['content--redesign']]: isClustersRedesign,
          })}
        >
          {label && <div className={styles['label']}>{label}</div>}

          {isCounter && (
            <div
              className={classNames(styles['count'], {
                [styles['promotion']]: !isNewbuildingOnProPlus && !isFavorite && !hasNewobject,
              })}
            >
              {formatBalloonCount(count, isClustersRedesign ? 99 : undefined)}
            </div>
          )}

          <div className={styles['price']}>{price}</div>
          {hasIcon && icon}
        </div>

        {isShowDetails && details && (
          <div
            className={classNames(styles['details'], {
              [styles['counter']]: isCounter,
            })}
          >
            {details}
          </div>
        )}
      </div>

      {isRedesign && (isHovered || isActive) && <div className={styles['promo-point']} />}
    </div>
  );
};
